/* eslint-disable @typescript-eslint/indent */
import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

const TITLE_LINE_HEIGHT = '1.25rem';

export const Section = styled.div<{ $expanded?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid
    ${(props: ThemeProp & { $expanded?: boolean }) =>
      props.$expanded ? props.theme.colors.primary.c500 : props.theme.colors.neutrals.c100};
`;

// The chevron sits on the title's line, as on a rule, however many kept columns are listed under it
export const SectionToggle = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const Chevron = styled.span<{ $expanded?: boolean }>`
  display: inline-flex;
  align-items: center;
  height: ${TITLE_LINE_HEIGHT};
  transform: rotate(${({ $expanded }: { $expanded?: boolean }) => ($expanded ? '0deg' : '-90deg')});
`;

export const SectionTitle = styled.div`
  line-height: ${TITLE_LINE_HEIGHT};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const Muted = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: normal;
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const Description = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const GridRow = styled.div<{ $highlighted?: boolean; $invalid?: boolean }>`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) minmax(0, 1fr) 7.5rem;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid
    ${(props: ThemeProp & { $highlighted?: boolean; $invalid?: boolean }) => {
      if (props.$invalid) return props.theme.colors.system.error.c500;
      return props.$highlighted ? props.theme.colors.primary.c300 : 'transparent';
    }};
`;

export const HeaderCell = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const ColumnCell = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  overflow-wrap: anywhere;
`;

export const SuggestedHint = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: normal;
  color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
`;

export const RowError = styled.div`
  grid-column: 1 / -1;
`;
/* eslint-enable @typescript-eslint/indent */

export const KeptColumnsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  overflow-wrap: anywhere;
`;

export const KeptColumnName = styled.span`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
`;

export const SavedAsDetail = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;
